var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFb(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.28 19.247v-7.513h2.535l.377-2.941H12.28V6.919c0-.849.237-1.43 1.455-1.43h1.544V2.867c-.751-.08-1.506-.12-2.262-.117-2.24 0-3.778 1.368-3.778 3.879v2.158H6.72v2.942h2.523v7.518h3.036z",
    fill: "#387"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjIiIGhlaWdodD0iMjIiIHZpZXdCb3g9IjAgMCAyMiAyMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEyLjI4MDMgMTkuMjQ3NFYxMS43MzQ0SDE0LjgxNDlMMTUuMTkxNiA4Ljc5MjgySDEyLjI4MDNWNi45MTkxNkMxMi4yODAzIDYuMDcwMzIgMTIuNTE2OCA1LjQ4OTE2IDEzLjczNSA1LjQ4OTE2SDE1LjI3ODdWMi44NjY1N0MxNC41Mjc2IDIuNzg2MDggMTMuNzcyNyAyLjc0NzIyIDEzLjAxNzMgMi43NTAxNkMxMC43NzcgMi43NTAxNiA5LjIzODc5IDQuMTE3ODIgOS4yMzg3OSA2LjYyODU3VjguNzg3MzJINi43MjA3VjExLjcyODlIOS4yNDQyOVYxOS4yNDc0SDEyLjI4MDNaIiBmaWxsPSIjMzM4ODc3Ii8+Cjwvc3ZnPgo=";
export { SvgFb as ReactComponent };